import styled from 'styled-components'
import { Colors, Typography, Spacing } from 'cio-design-library/design-tokens'
import Media from 'builder/styles/media'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;

  ${Media.Phone`
    gap: 16px;
  `}
`

export const ScoreDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const Title = styled.div`
  ${Typography.sizes.Body};
  color: ${Colors.Neutral90};
`

export const ScoreBadgeContainer = styled.div`
  display: flex;
  gap: ${Spacing['2XS']};
`

export const ScoreBadge = styled.div<{ $score: number }>`
  ${Typography.sizes.Tiny};
  font-weight: ${Typography.weights.demibold};
  color: ${Colors.White};
  padding: 2px 4px;
  background: ${props =>
    props.$score <= 30
      ? Colors.Red40
      : props.$score > 30 && props.$score <= 70
      ? Colors.Amber40
      : Colors.Green40};
  border-radius: 4px;
`
